export const UNREAD_CATEGORY_ID = Math.random().toString();
